<SveltePopover action={trigger} placement={`${alignment}-center`} arrowColor="white" spacing="5px" {zIndex} {extraStyles}>
    <svelte:fragment slot="target">
        <slot></slot>
    </svelte:fragment>

    <div slot="content" class="popover-wrapper">
        <h3 class="popover-title">
            <slot name="title">{title}</slot>
        </h3>
        <div class="popover-content">
            <slot name="body">
                {#if html}
                    {@html content}
                {:else}
                    { content }
                {/if}
            </slot>
        </div>
    </div>
</SveltePopover>

<style lang="less">
    .popover-title, .popover-content {
        width: 220px;
        text-align: left;
    }

    .popover-content {
        overflow-y: hidden;
        background: white;
        color: #444;
    }

    .popover-wrapper {
        border: 1px solid #AAA;
        border-radius: 2px;
        box-shadow: 0px 0px 4px 2px rgba(0,0,0,0.2);
    }
</style>

<script lang="ts">
    import SveltePopover from "@/vendor/svelte-popover/SveltePopover.svelte";

    export let title: string = "";
    export let content: string = "";
    export let alignment: "top"|"bottom"|"right"|"left" = "top";
    export let trigger: "click"|"hover" = "click";
    export let html: boolean = false;
    export let zIndex: number = 1000;
    export let extraStyles: string = "";
</script>

